@if (outlets?.length === 1) {
<div class="reset-accordion one-outlet"
     [class.outlets-selector-accordion]="!isSeparatedView"
     [class.outlets-separated-selector-accordion]="isSeparatedView">
  @for (outlet of outlets; track outlet.id) {
  <div class="accordion-item bg-white">
    <div class="os-header"
         [class.show-time]="outletAccordionOptions?.showEarliestTime">
      <div>
        <div class="fw-bold text-overflow">{{ outlet.name }}</div>

        @if (outletActionStateMap[outlet.id]?.messageKey) {
          <div class="outlet-disabled-hint font-xs"
               [translate]="outletActionStateMap[outlet.id].messageKey">
          </div>
        }

        @if (outletAccordionOptions?.showEarliestTime) {
          <ui-earliest-pick-up
            class="d-block font-xs"
            [outlet]="outlet"
          ></ui-earliest-pick-up>
        }
      </div>
    </div>

    <ui-accordion-outlet
      class="d-block accordion-body"
      [outlet]="outlet"
      [scheduleOverrides]="scheduleOverridesByOutletId[outlet.id] || []"
      [showNext]="showNext"
      [nextText]="nextText"
      [hideNextButton]="outletActionStateMap[outlet.id]?.hideNextButton"
      [options]="outletAccordionOptions"
      [scheduleType]="scheduleType"
      (onNext)="onNext.emit($event)"
    ></ui-accordion-outlet>
  </div>
  }
</div>
}

@if (outlets?.length > 1) {
<div class="reset-accordion"
     [class.outlets-selector-accordion]="!isSeparatedView"
     [class.outlets-separated-selector-accordion]="isSeparatedView">

  <div ngbAccordion #acc="ngbAccordion"
       [closeOthers]="true"
       [animation]="false"
       (shown)="outletChanged({ panelId: $event, nextState: true })"
       (hidden)="outletChanged({ panelId: $event, nextState: false })">
    @for (outlet of outlets; track outlet.id) {
    <div [ngbAccordionItem]="panelIdPrefix + outlet.id">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <div class="os-header"
               [id]="destinationPrefix + outlet.id"
               [class.show-time]="outletAccordionOptions?.showEarliestTime"
               [class.outlet-expanded]="isPanelActive(outlet.id)">

            <i [class.icon-radiobox-blank]="!isPanelActive(outlet.id)"
               [class.icon-radiobox-marked]="isPanelActive(outlet.id)"
               [class.primary-color]="isPanelActive(outlet.id)"></i>
            <div>
              <div class="fw-bold text-overflow">{{ outlet.name }}</div>

              @if (outletActionStateMap[outlet.id]?.messageKey) {
                <div class="outlet-disabled-hint font-xs"
                     [translate]="outletActionStateMap[outlet.id].messageKey">
                </div>
              }

              @if (outletAccordionOptions?.showEarliestTime) {
                <ui-earliest-pick-up
                  class="d-block font-xs"
                  [outlet]="outlet"
                ></ui-earliest-pick-up>
              }
            </div>

            @if (outlets.length !== 1) {
              <i class="text-pink"
                 [class.icon-chevron-down]="!isPanelActive(outlet.id)"
                 [class.icon-chevron-up]="isPanelActive(outlet.id)"></i>
            }
          </div>
        </button>
      </h2>

      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <ui-accordion-outlet
              [outlet]="outlet"
              [scheduleOverrides]="scheduleOverridesByOutletId[outlet.id] || []"
              [showNext]="showNext"
              [nextText]="nextText"
              [hideNextButton]="outletActionStateMap[outlet.id]?.hideNextButton"
              [options]="outletAccordionOptions"
              [scheduleType]="scheduleType"
              (onNext)="onNext.emit($event)"
            ></ui-accordion-outlet>
          </ng-template>
        </div>
      </div>
    </div>
    }
  </div>
</div>
}
